//React
import { useCallback, useState, useEffect } from 'react'
// Librerias

// Servicios
import { ChatbotAccesoModel, obtenerChtChatbotAcceso } from 'actions/ChtChatbotAccesoAction';
//Hooks

/**
 * Obtiene acceso a chatbot para el usuario
 *
*/
const useGetAccesoChatbot = () => {
    const [acceso, setAcceso] = useState(parseDataAccesoChatbot(ChatbotAccesoModel));
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const getInfo = useCallback(async () => {
        const [res, err] = await obtenerChtChatbotAcceso();

        setAcceso(parseDataAccesoChatbot(res?.data));

        setError(err);

        setIsLoading(false);
    }, []);

    const refresh = useCallback(async () => {
        await getInfo();
    }, [getInfo]);


    useEffect(() => {
        getInfo();
    }, [getInfo]);

    return {
        acceso,
        isLoading,
        error,
        refresh
    }
}

export default useGetAccesoChatbot;

const parseDataAccesoChatbot = (data) => {
    return {
        id: data?.id,
        nombreUsuario: data?.nombreUsuario,
        usuarioId: data?.usuarioId,
        habilitado: data?.habilitado
    }
}